import { render, staticRenderFns } from "./speciality.vue?vue&type=template&id=ee0656f6"
import script from "./speciality.vue?vue&type=script&lang=js"
export * from "./speciality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports